'use client'
import * as React from 'react'

interface FeedRouteContextValue {
  basePath: '/masterfeed' | '/feed'
}

const FeedRouteContext = React.createContext<FeedRouteContextValue>({ basePath: '/masterfeed' })

export function FeedRouteProvider({
  basePath,
  children,
}: {
  basePath: '/masterfeed' | '/feed'
  children: React.ReactNode
}) {
  const value = React.useMemo(() => ({ basePath }), [basePath])
  return <FeedRouteContext.Provider value={value}>{children}</FeedRouteContext.Provider>
}

export function useFeedRoute() {
  return React.useContext(FeedRouteContext)
}
